import { createContext, useContext, useState } from 'react';

const ClientModalContext = createContext();

export const ClientModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [client, setClient] = useState(null);
  const [mode, setMode] = useState('create'); // 'create' or 'edit'

  const openModal = (clientData = null, modalMode = 'create') => {
    setClient(clientData);
    setMode(modalMode);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    // Clear after animation
    setTimeout(() => {
      setClient(null);
      setMode('create');
    }, 200);
  };

  const openCreateModal = () => {
    openModal(null, 'create');
  };

  const openEditModal = (clientData) => {
    openModal(clientData, 'edit');
  };

  const value = {
    isOpen,
    client,
    mode,
    openModal,
    closeModal,
    openCreateModal,
    openEditModal,
  };

  return (
    <ClientModalContext.Provider value={value}>
      {children}
    </ClientModalContext.Provider>
  );
};

export const useClientModal = () => {
  const context = useContext(ClientModalContext);
  if (!context) {
    throw new Error('useClientModal must be used within a ClientModalProvider');
  }
  return context;
};


